import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], searchText: string): any[] {
    if (!items) return [];
    if (!searchText) return items;
    searchText = searchText.toString().toLowerCase();
    return items.filter(it => {
      return it.includes(searchText);
    });
  }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/pipe/filter.pipe.ts